import { SITE_URL } from '@/lib/seo';
import { useLanguage } from '@/contexts/LanguageContextNew';
import { useSchemaDOM } from '@/hooks/useSchemaDOM';

interface ServiceEnrichedSchemasProps {
  serviceName: string;
  category: 'bpo' | 'digital' | 'consulting';
}

export function ServiceEnrichedSchemas({ serviceName, category }: ServiceEnrichedSchemasProps) {
  const { language } = useLanguage();
  const slug = serviceName.toLowerCase().replace(/\s+/g, '-');

  // Only ItemList — WebPage is already emitted by SEOHead.tsx
  const schemas = [
    {
      '@context': 'https://schema.org', '@type': 'ItemList',
      name: category === 'bpo' ? 'BPO & Call Center Services' : 'Digital Factory Services',
      numberOfItems: 8, inLanguage: language,
    },
  ];

  useSchemaDOM(schemas, `service-enriched-${slug}`, [language, serviceName]);
  return null;
}
